import UserItem from './UserItem'

export default class ChildBook {
  constructor (data) {
    if (!data || !data.user_item) throw new Error('Invalid ChildBook data.')

    this.childId = data.child_id ?? null

    this.userItem = new UserItem(data.user_item, this)

    this.progress = data.progress ?? 0

    this.viewedLessonsID = data.views_lessons_id ?? []
  }
}
